import React from "react";

export default function TableCell({ children, textAlign = 'center' }) {
  return <td className={`px-6 py-4 whitespace-nowrap text-${textAlign}`}>{children}</td>;
}
